class NotificationService {
    constructor() {
        Object.defineProperty(this, "hasPermission", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "checkSupport", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return "Notification" in window;
            }
        });
        Object.defineProperty(this, "requestPermission", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async () => {
                try {
                    if (!this.checkSupport()) {
                        console.log("Este navegador no soporta notificaciones");
                        return false;
                    }
                    if (Notification.permission === "granted") {
                        this.hasPermission = true;
                        return true;
                    }
                    if (Notification.permission !== "denied") {
                        const permission = await Notification.requestPermission();
                        this.hasPermission = permission === "granted";
                        return this.hasPermission;
                    }
                    return false;
                }
                catch (error) {
                    console.error("Error al solicitar permisos:", error);
                    return false;
                }
            }
        });
        Object.defineProperty(this, "showNotification", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: async (title, options = {}) => {
                try {
                    if (!this.hasPermission) {
                        const granted = await this.requestPermission();
                        if (!granted) {
                            console.log("No hay permiso para mostrar notificaciones");
                            return;
                        }
                    }
                    const defaultOptions = {
                        body: options?.message ?? "",
                        icon: "/img/icons/android-chrome-192x192.png",
                        badge: "/img/icons/android-chrome-192x192.png",
                        tag: "microcentrum-notification",
                        silent: false,
                    };
                    const notification = new Notification(title, {
                        ...defaultOptions,
                        ...options,
                    });
                    notification.onclick = () => {
                        window.focus();
                        notification.close();
                    };
                    return notification;
                }
                catch (error) {
                    console.error("Error al mostrar notificación:", error);
                }
            }
        });
        this.hasPermission = false;
    }
}
export const notificationService = new NotificationService();
